export default "__VITE_ASSET__BxHFmCGk__"